import PersonAddIcon from '@mui/icons-material/PersonAdd';
import InventoryIcon from '@mui/icons-material/Inventory';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PageHeader from "../components/PageHeader/PageHeader";

const STEPS = [
  {
    number: "01",
    Icon: PersonAddIcon,
    title: "Registro del actor",
    description: "Cada participante ingresa su información en la plataforma.",
  },
  {
    number: "02",
    Icon: InventoryIcon,
    title: "Registro del material",
    description: "Se documenta el flujo desde origen hasta transformación.",
  },
  {
    number: "03",
    Icon: FactCheckIcon,
    title: "Validación",
    description: "La información es revisada y autorizada por entidad verificadora.",
  },
  {
    number: "04",
    Icon: WorkspacePremiumIcon,
    title: "Certificación",
    description: "Se genera un certificado único, trazable e inalterable.",
  },
];

function HowItWorks() {
  return (
    <>
      <PageHeader eyebrow="Cómo funciona" title="Proceso claro, estructurado y confiable" />

      <section className="bg-white">
        <div className="max-w-[1100px] mx-auto py-96 px-40 text-center">
          <h2 className="text-36 font-extrabold text-[#1E3A8A] mb-72 leading-tight">
            EcoRep guía a cada actor por un flujo definido que garantiza trazabilidad y confiabilidad en cada etapa.
          </h2>

          <div className="relative flex items-start justify-center">
            {/* Connector line between bubbles */}
            <div className="absolute top-[62px] left-[calc(12.5%+62px)] right-[calc(12.5%+62px)] h-[2px] bg-[#BFDBFE] z-0" />

            {STEPS.map(({ number, Icon, title, description }) => (
              <div key={number} className="flex-1 flex flex-col items-center gap-24 px-16 relative z-10">
                <div className="w-[124px] h-[124px] rounded-full bg-[#EFF6FF] border-2 border-[#BFDBFE] flex flex-col items-center justify-center gap-4 transition-colors duration-200 hover:bg-[#DBEAFE] hover:border-[#1A56DB]">
                  <span className="text-12 font-extrabold text-[#1A56DB] tracking-[0.06em] leading-none">
                    {number}
                  </span>
                  <Icon className="!text-32 text-[#1A56DB]" />
                </div>
                <div className="text-center">
                  <h3 className="text-20 font-bold text-[#1E3A8A] mb-10 leading-[1.3]">
                    {title}
                  </h3>
                  <p className="text-18 text-[#475569] leading-[1.65] m-0">
                    {description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default HowItWorks;
